import React  from 'react';
import {Link, browserHistory} from 'react-router';
import { connect } from 'react-redux';
import flag from '../assets/images/flags/gb.svg';
import shield from '../assets/images/logo-small.png';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import IdleTimer from 'react-idle-timer';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timeout: 60000,
            remaining: null,
            isIdle: false,
            lastActive: null,
            elapsed: null
        };
    }

    resetToStart() {
        browserHistory.push('/');
    }

    render() {
        return (
            <IdleTimer ref="idleTimer" idleAction={this.resetToStart} timeout={this.state.timeout} startOnLoad={true}>
                <div className="pb-5">
                    <ToastContainer position="top-right" type="default" autoClose={5000} hideProgressBar={true} newestOnTop={true} closeOnClick pauseOnHover />
                    <Link to="/" className="logo">
                        <img src={shield} alt="" />
                    </Link>
                    <nav className="navbar navbar-toggleable-sm navbar-inverse bg-inverse text-uppercase mb-5">
                        <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon" />
                        </button>

                        <div className="collapse navbar-collapse" id="navbar">
                            <ul className="navbar-nav text-center align-items-center justify-content-center">
                                <li className="nav-item"><a href="#" className="nav-link" onClick={browserHistory.goBack}>Go back</a></li>
                                <li className="nav-item"><Link to="/" className="nav-link">Start again</Link></li>
                                <li className="nav-item"><Link to="/choices" className="nav-link">My choices <span className="badge badge-primary ml-2">{this.props.choices.length}</span></Link></li>
                                <li className="nav-item"><Link to="/browse" className="nav-link">Browse all</Link></li>
                                <li className="nav-item"><a href="#" className="nav-link">Language <img src={flag} className="img-fluid rounded-circle ml-2" /></a></li>
                            </ul>
                        </div>
                    </nav>
                    {/* Each smaller components */}
                    {this.props.children}
                </div>
            </IdleTimer>
        );
    }

}


// Maps state from store to props
const mapStateToProps = (state) => {

    return {
        // You can now say this.props.books
        choices: state.choices,
    };

};

App.propTypes = {
    choices: PropTypes.array,
    children: PropTypes.element.isRequired,
};

// Use connect to put them together
export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js